export default __webpack_public_path__ + "static/media/exchange.ab10ddb1.svg";